import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';
import faker from 'faker';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import _ from 'lodash';
import HeaderPage from './HeaderPage';
import session from '../models/Session';
import EndSessionContainer from '../containers/EndSessionContainer';
import ManagementParticipantsSessionCard from '../components/ManagementParticipantsSessionCard';
import DescriptiveCard from '../components/DescriptiveCard';
import CustomFieldsCard from '../components/CustomFieldsCard';
import RemoveUserConfirmation from '../components/RemoveUserConfirmation';
import Footer from '../components/Footer';
import DraftParentsGroup from '../components/DraftParentsGroup';
import { Redirect } from 'react-router-dom';
import Draft from '../models/Draft';

const styles = {
  promptCardWrapper: {
    margin: '0 auto',
    width: '37.5rem',
  },
  text: {
    border: '0.0625rem solid #CBCBCB',
    padding: '0.3125rem',
    textAlign: 'center',
    color: '#979797',
    borderRadius: '1.5rem',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontFamily: 'Lato, Arial',
    marginBottom: '1rem',
    '&:hover': {
      color: '#F2F3F1',
      background: '#979797',
      fontSize: '0.875rem',
      fontFamily: 'Lato, Arial',
    },
  },
  hide: {
    display: 'none',
  },
  waiting: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 157px)',
  },
  startJamLabel: {
    fontFamily: 'Lato, Arial',
    fontSize: '14px',
    color: '#34A5DA',
    marginBottom: '0.5rem',
  },
  wrapper: {
    marginBottom: '2rem',
  },
};

const GET_DRAFT_BY_ID = id => gql`
  query {
    draftWithParents(_id: "${id}") {
      _id
      title,
      blurb,
      image,
      createdAt,
      createdBy {
        _id 
        displayName 
        image
      }
      __typename,
      participants {
        displayName,
        image,
        _id
      },
     parents {
      image
      parentType
      prompt
      _id
      blurb
      title
      name
      }
      sessions {
        index,
        _id
        fields
      }
      template {
        _id,
        name,
        slug,
        sessions {
          description,
          index,
          output {
            name,
            slug,
            type,
            _id
          }
        }
      }
    }
  }
`;


function RenderSessionDescriptiveCard(props) {
  const {
    sessions, sessionNumber, onChange, value, classes, draft,
  } = props;
  return sessions.map((session, index) => {
    // TODO: Grey: Fix hidden output with value from session
    session.index = index; 
    return ( <DescriptiveCard key={index} disabled isShowing label={`Session ${index + 1}:`} blurb={session.description} extraClass={sessionNumber >= index  ? classes.hide : ''}>
      {(sessionNumber === (index - 1)) ? session.output.map((prop, index) => (
          <div key={index}> 
            <DraftParentsGroup {...{
              session, onChange, value, draft
            }}
            />
          </div>
        ))
        : ''}
    </DescriptiveCard>
  )});
}

function ShowEndedSession(props) {
  const {
    children, classes, onClick, hideEndedSession,
  } = props;
  return (
    <div className={classes.wrapper}>
      <div onClick={onClick} className={classes.text}>
        {hideEndedSession ? 'Show ended session' : 'Hide ended session'}
      </div>
      <div className={hideEndedSession ? classes.hide : ''}>
        {children}
      </div>
    </div>
  );
}

class CrewDraftPage extends Component {
  componentDidMount() {
    if (this.props.endSession) {
      this.props.endSession.setup();
    }
  }

  componentWillUnmount() {
    this.props.endSession.destroy();
  }

  render() {
    const { classes, endSession } = this.props;

    // if (!(endSession.state.draftSessions && endSession.state.draftSessions.current && endSession.state.draftSessions.current.description)) {
    //   return null;
    // }


    const descriptionHeader = `As a Jam Leader, you have the option to remove any participants 
      who were not present and to view the upcoming agenda for the next sessions.`;
    const descriptionHeader2 = 'If need be, you can store this session as “In Progress” and come back to work on it later.';
    let { number, id } = this.props.match.params;

    number = parseInt(number);

    return (
      <Query query={GET_DRAFT_BY_ID(this.props.match.params.id)}>
        {({ loading, error, data }) => {
          if (loading) return <div>Loading...</div>;
          if (error) return <div>Error :(</div>;

          if (session.user._id !== data.draftWithParents.createdBy._id) {
            return ( 
              <div className={classes.waiting}>
                <h1>Waiting for next session to start...</h1>
              </div>
            )
          }

          if (data.draftWithParents.createdBy._id !== session.getUser()._id && !_.some(data.draftWithParents.participants, { _id: session.getUser()._id })) {
            return ( <Redirect to="/" /> );
          } 

          if (!(data.draftWithParents && endSession.state.draft && session.store.draft)) {
            session.startJam(data.draftWithParents);
          }

          return (
            <div>
              <HeaderPage titleHeader={`Session ${number} Ended`} descriptionHeader2={descriptionHeader2} descriptionHeader={descriptionHeader} showBtns={false} />
              <div className={classes.promptCardWrapper}>
                <ManagementParticipantsSessionCard removeFromPreviousBtn={endSession.removeFromPreviousBtn} removeFromFutureBtn={endSession.removeFromFutureBtn} participants={data.draftWithParents.participants} createdBy={data.draftWithParents.createdBy} />
                <RemoveUserConfirmation
                  participant={
                    {
                      id: '1212',
                      image: faker.image.avatar(),
                      displayName: faker.name.findName(),
                    }
                  }
                  modal={endSession.state.modal}
                  handleCancelBtn={endSession.toggleModal}
                  handleActionBtn={endSession.toggleModal}
                  handleToggle={endSession.toggleModal}
                />
                <HeaderPage titleHeader="Jam Sessions" descriptionHeader="Below is the agenda for the upcoming sessions." showBtns={false} />
                <ShowEndedSession onClick={endSession.handleClickShowEndedSession} hideEndedSession={endSession.state.hideEndedSession} classes={classes}>

                  {_.range(0, number).map(i => (
                    <DescriptiveCard key={i} label={`Session ${i + 1}:`} isShowing blurb={data.draftWithParents.template.sessions[i].description}>
                      <DraftParentsGroup key={i} endSession={true} session={data.draftWithParents.template.sessions[i]} onChange={endSession.handleChange} draft={data.draftWithParents} />
                    </DescriptiveCard>
                  ))}

                  
                </ShowEndedSession>
                {(data.draftWithParents.template.sessions.length > number ) ? <div className={classes.startJamLabel}>{`Jam will start with session ${number + 1}`}</div> : ''}
                <RenderSessionDescriptiveCard classes={classes} sessionNumber={number - 1} onChange={endSession.handleChange} value={endSession.state.textbox} sessions={data.draftWithParents.template.sessions} />
                <DescriptiveCard label="Wrap Up:" isShowing blurb="The Jam Leader will be able to tweak/form any necessary changes. Note: This is not a session and any changes will be tracked." />
              </div>
              <Footer actionBtnLabel={(data.draftWithParents.template.sessions.length > number ) ? 'Next session' : 'Wrap Up'} draftTo="" draft="Store to Work in Progress" to={(data.draftWithParents.template.sessions.length > number ) ? `/crew/${id}/${number + 1}/start` : `/crew/${id}/wrapup`} />
            </div>
          );
        }}
      </Query>
    );
  }
}

function EndSessionPageWrapper(props) {
  const { classes } = props;

  return (
    <Subscribe to={[EndSessionContainer]}>
      { endSession => (
        <div>
          {endSession && (
          <CrewDraftPage {...props} classes={classes} endSession={endSession} />
          )}
        </div>
      )}
    </Subscribe>
  );
}

export default injectSheet(styles)(EndSessionPageWrapper);



// WEBPACK FOOTER //
// ./src/pages/EndSessionPage.js